<template>
  <div 
    :class="{'chapter': page.layout === 'chapter'}"
    class="ec-page">
    <page-header 
      :headline="page.headline" 
      :description="page.description"
    />
    <component
      :is="currentView"
      :ref="page.pageType === 'normal' ? 'questionGroup' : 'module'"
      :questions="page.questions"
      :module="page.module"
    />
  </div>
</template>
<script>
    import QuestionGroup from './QuestionGroup.vue'
    import Module from './module/Module.vue'
    import PageHeader from './PageHeader.vue'


    export default {
        name: "Page",
        components: { PageHeader },
        props: {
            page: {
                required: true,
                type: Object
            }
        },
        data: function () { return {
            
        }},
        computed: {
            currentView: function () {
                if(this.page.pageType === 'normal') {
                    return QuestionGroup
                }

                if(this.page.pageType === 'module') {
                    return Module
                }

                return null
            },
        },
        updated() {
            
        },
        methods: {
            checkForSendRdy() {
            },
            getResponseData() {
                if(this.$store.readOnly) {
                    return {}
                } 

                let responseData = {}

                if(this.page.pageType === 'normal') {
                    responseData.questions = this.$refs.questionGroup.getResponseData()
                }

                if(this.page.pageType === 'module') {
                    responseData.module = this.$refs.module.getResponseData()
                }

                return responseData
            }
        },
    }
</script>
